import React from 'react';
import PropTypes from 'prop-types';
import css from './WarningMessage.css';
import Icon from 'SF/MaterialIcon';

const WarningMessage = ({message}) => (
  <div className={css['container']} data-testid="warning-message">
    <div><Icon icon='info' aria-hidden='true' /></div>
    <div>{message}</div>
  </div>
);

WarningMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default WarningMessage;
